import React from 'react';
import AuthForm from '../components/AuthForm';

const RegisterPage = () => {
  return <AuthForm initialMode="register" />;
};

export default RegisterPage; 